import { DropdownOptionsService } from '../../../../../core/services/dropdown-options.service';
import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { LogisticsService } from 'src/app/features/transport-operation/services/logistics.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { deepCopy, getDataScopeByPermission, getForwarderByPermission, isNullOrEmpty, getFacilityByPermission } from 'src/app/core/utils/common-functions';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as ValidationFuncs from 'src/app/core/utils/validation-functions';
import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { FileUpload } from 'primeng/fileupload';
import { RfqSettingService } from '../../../service/rfq-setting.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';

@Component({
  selector: 'laas-rfq-upload',
  templateUrl: './rfq-upload.component.html',
  styleUrls: ['./rfq-upload.component.scss']
})
export class RfqUploadComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewRFQSetting;

  documentOptions: any[];
  selectedDocument: string;
  docs: any[];
  isLoading: boolean;
  selectedDoc: any;
  forwarder: string;
  yesNoOption: any[] = [];
  forwarderOptions: any[] = [];
  previewData: any[] = [];
  columns: any[] = [];

  showTable1: boolean = false;
  showTable2: boolean = false;
  uploadBtn: boolean = true;
  rfqSample: any[] = [];
  inboundFormat: any[] = [];
  outboundFormat: any[] = [];

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private dOService: DeliveryOrderService,
    private facilityService: FacilityService,
    private rfqSettingService: RfqSettingService
  ) {
    super(injector);

    this.documentOptions = [];
    this.selectedDocument = "";
    this.docs = [];
    this.isLoading = false;
    this.forwarder = "";

    this.yesNoOption = [
      { label: '顯示貨代', value: 0 },
      { label: '不顯示貨代', value: 1 }
    ];

  }


  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    const facility = this.laasSetting.facility;

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return (this.userProfile.userType == UserType.SuperAdmin.toString() ||
            this.userProfile.userType == UserType.Shipping.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

  }

  rfqFile: any;


  preview(event: any): void {

    console.log("preview");
    this.showTable1 = false;
    this.showTable2 = false;
    this.isLoading = true;
    this.uploadBtn = true;
    this.rfqSample = [];
    this.inboundFormat = [];
    this.outboundFormat = [];

    if (isNullOrEmpty(this.forwarder)) {
      this.toastService.info(this.translateService.instant('RFQSetting.Info.EnterForwarder'), false);
      return;
    }

    this.rfqSettingService.preview(event.files[0], this.forwarder, this.userProfile.userName).subscribe({
      next: rsp => {

        console.log("rsp:", rsp);

        if (rsp.message == "NO_FORWARDER") {
          this.toastService.info(this.translateService.instant('RFQSetting.Info.EnterForwarder'), false);
          return;
        }

        if (rsp.message == "FAIL") {
          this.toastService.info(this.translateService.instant('RFQSetting.Info.FormatError'), false);
          return;
        }

        if (rsp.type == "1") {
          this.rfqSample = rsp.rfqSample;
          this.showTable1 = true;
        } else {
          this.inboundFormat = rsp.inboundFormat;
          this.outboundFormat = rsp.outboundFormat;
          this.showTable2 = true;
        }

        this.rfqFile = event.files[0];
        this.uploadBtn = false;
        this.toastService.success(this.translateService.instant('RFQSetting.Success.PreviewSuccess'), false);
        this.isLoading = false;
      },
      error: rsp => {
        console.log(rsp);
        this.isLoading = false;
        this.toastService.warn(this.translateService.instant('RFQSetting.Alert.PreviewFail'), false);
      },
      complete: () => {

      }
    });
  }


  async upload(): Promise<void> {

    this.isLoading = true;

    if (this.userProfile.userType !== UserType.SuperAdmin.toString()) {
      const facilityList = getFacilityByPermission(this.userProfile, this.permissionCode);

      const facilityValidity = await this.validateFacility(this.rfqSample, 'RFQ.Facility', facilityList, 0)
          && await this.validateFacility(this.inboundFormat, '倉別', facilityList, 1)
          && await this.validateFacility(this.outboundFormat, '倉別', facilityList, 1);

      if (!facilityValidity) {
        this.isLoading = false;
        return;
      }
    }

    this.rfqSettingService.uploadFile(this.rfqFile, this.laasSetting.facility, this.forwarder, this.userProfile.userName).subscribe({
      next: rsp => {
        this.rfqFile = null;
        this.isLoading = false;
        this.uploadBtn = true;
        this.toastService.success(this.translateService.instant('RFQSetting.Success.UploadSuccess'), false);
        // 上傳成功轉導至查詢頁
        console.log("rsp: ", rsp);
        if(rsp && !isNullOrEmpty(rsp.startSeqNo) && !isNullOrEmpty(rsp.endSeqNo)){
          this.routeStateService.navigateTo('/Setting/RfqSetting', {
            startSeqNo: rsp.startSeqNo,
            endSeqNo: rsp.endSeqNo
          });
        }
      },
      error: rsp => {
        console.log(rsp);
        this.isLoading = false;
        this.uploadBtn = true;
        this.toastService.error(this.translateService.instant('RFQSetting.Error') + ": " + rsp.error.errorMsg);
      },
      complete: () => {

      }
    });
  }

  // rfqType: 0 = normal, 1 = inbound, outbound
  async validateFacility(rfq: any[], column: string, checkFacilityList: any, rfqType: number): Promise<boolean> {
    const facilitySet = new Set<string>();

    if (rfq.length > 0) {
      const facilityIndex = rfq[0].findIndex((x: any) => x === column);
      let slice = 0;
      if (rfqType === 0) {
        slice = 2;
      } else if (rfqType === 1) {
        slice = 1;
      }

      rfq.map((x: any) => x[facilityIndex])
          .filter(x => !isNullOrEmpty(x))
          .slice(slice)
          .forEach(x => {
            const facilities = x.split(',');
            facilities.forEach((facility: string) => {
              facilitySet.add(facility);
          });
      });
    }

    if (facilitySet.size > 0) {
      const facilitySetList = [...facilitySet];

      for (const x of facilitySetList) {
        const result = await this.facilityService.getForwarderOptions(x).toPromise();
        if (result.every((y: any) => y.optionCode !== this.forwarder)) {
          this.toastService.error(this.translateService.instant('RFQImport.Error.ForwarderNotInFacility'));
          return false;
        }
      }

      if (!facilitySetList.every(x => checkFacilityList.some((y: any) => x === y))) {
        this.toastService.error(this.translateService.instant('RFQImport.Error.CheckFacilityForwarderAuth'));
        return false;
      }
    }

    return true;
  }

  onClear() {
    this.showTable1 = false;
    this.showTable2 = false;
    this.uploadBtn = true;
  }



  showUploadBtn() {
    if (this.uploadBtn) {
      return true;
    } else {
      return false;
    }
  }

  templateDownloadBtn(type: number): void {

    var fileType = type == 0 ? 'RFQSetting' : 'RFQSettingInboundOutbound';
    var fileName = type == 0 ? 'RFQ範本' : '進出口RFQ範本';

    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.dOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName + '.xlsx';
          link.click();
        });
      }
    });
  }

}
